__turbopack_context__.v({
  "button": "index-module__NS4ehq__button",
  "buttonReject": "index-module__NS4ehq__buttonReject",
  "inner": "index-module__NS4ehq__inner",
  "root": "index-module__NS4ehq__root",
});
